import Repository from './Repository';

const resource = '/subjects';

export default {
    get(payload)        {return Repository.get(`${resource}`, payload);},
    show(id)            {return Repository.get(`${resource}/${id}`);},
    create(payload)     {return Repository.post(`${resource}`, payload);},
    getFullSubject(payload) {return Repository.get(`${resource}/full`, payload);},
}